import React from 'react'
import { ClientIcon } from '../ClientIcon'
import {
  IconBooks,
  IconEdit,
  IconHelpCircle,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
  IconMessageCircle,
  IconSearch,
} from '@tabler/icons-react'

const icons = {
  compose: IconEdit,
  search: IconSearch,
  library: IconBooks,
  chat: IconMessageCircle,
  help: IconHelpCircle,
  collapse: IconLayoutSidebarLeftCollapse,
  expand: IconLayoutSidebarLeftExpand,
}

/** Tabler outline icons inherit the client theme and the surrounding square tile. */
export function ChatGlyph({ name, size = 20 }: { name: keyof typeof icons; size?: number }) {
  const Icon = icons[name]
  return (
    <ClientIcon
      name={name}
      group='navigation'
      size={size}
      fallback={<Icon size={size} stroke={1.75} aria-hidden='true' focusable='false' />}
    />
  )
}
